<template>
    <div class="me">
        <div class="left">
            <div>
                <div>
                    <div v-if="info.isNotCertified=='2'">企业认证</div>
                </div>
                <div>
                    <i v-if="!info.avatar" class="el-icon-user-solid"></i>
                    <img v-else :src="$store.state.imgUrl+info.avatar">
                </div>
                <div class="fz18 fwB c333">{{info.nickname}}</div>
                <div class="fz14 blue">{{info.isNotCertified=='2'?info.companyName:'未认证'}}</div>
            </div>
            <div v-show="$store.state.orgCode==$store.state.businessNo">
                <div class="fz18 c333">发布</div>
                <div>
                    <div @click="goRouter('/publish')">
                        <img src="../../assets/fbjp.png">
                    </div>
                    <div @click="goRouter('/publish_yxmh')">
                        <img src="../../assets/fbyxmh.png">
                    </div>
                </div>
            </div>
            <div>
                <div :class="$route.name=='ME'||$route.name=='Info'?'ac':''" @click="goRouter('/me')">用户资料</div>
                <div :class="$route.name=='MyOrder'?'ac':''" @click="goRouter('/my_order')">我的订单</div>
                <div :class="$route.name=='CompanyList'||$route.name=='Company'?'ac':''" @click="goCompany">公司认证</div>
                <div :class="$route.name=='Geren'?'ac':''" v-if="isMain==1" @click="goGeren">个人认证</div>
            </div>
        </div>
        <div class="right">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "Me",
        data() {
            return {
                isMain: sessionStorage.getItem('isMain'),
                info: {
                    isNotCertified: null
                }
            }
        },
        created() {
            this.getUser();
        },
        methods: {
            goGeren() {
                this.$router.push({
                    path: '/geren',
                    query: {
                        id: this.$store.state.userId
                    }
                })
            },
            goCompany() {
                if (sessionStorage.getItem('isMain') == 1&&sessionStorage.getItem('isNotCertified')==2) {
                    this.goRouter('/company_list')
                } else {
                    this.$router.push({
                        path: '/company',
                        query: {
                            id: this.$store.state.userId
                        }
                    })
                }
            },
            getUser() {
                this.request.get(this.$store.state.httpUrl + "userDetails/findUserPerson", {
                    params: {
                        id: this.$store.state.userId,
						flag: this.$store.state.isPerson
                    }
                }).then(res => {
                    if (res.status == 200) {
                        this.info = res.data;
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .me {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 24px 0 50px 0;
    }

    .left {
        width: 260px;
    }

    .left>div {
        background: #FFFFFF;
        border-radius: 10px;
        box-sizing: border-box;
    }

    .left>div:nth-child(1) {
        /* height: 228px; */
        padding: 20px 16px;
    }

    .left>div:nth-child(1)>div:nth-child(1)>div {
        width: 70px;
        height: 26px;
        background: #F3B400;
        border-radius: 10px;
        font-size: 12px;
        color: #FFFFFF;
        text-align: center;
        line-height: 24px;
        margin-left: calc(100% - 70px);
    }

    .left>div:nth-child(1)>div:nth-child(2) {
        width: 68px;
        height: 68px;
        box-shadow: 1px 1px 15px 0px rgba(197, 213, 225, 0.46);
        border-radius: 50%;
        text-align: center;
        line-height: 68px;
        margin: 0 auto;
        color: #FFFFFF;
        background: #E7E7E7;
        font-size: 30px;
    }

    .left>div:nth-child(1)>div:nth-child(2)>img {
        width: 68px;
        height: 68px;
        border-radius: 50%;
    }

    .left>div:nth-child(1)>div:nth-child(3) {
        margin-top: 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid #CCCCCC;
    }

    .left>div:nth-child(1)>div:nth-child(4) {
        margin-top: 18px;
    }

    .left>div:nth-child(2) {
        padding: 0 24px;
        margin-top: 18px;
        padding-bottom: 24px;
    }

    .left>div:nth-child(2)>div:nth-child(1) {
        line-height: 66px;
        text-align: left;
    }

    .left>div:nth-child(2)>div:nth-child(2)>div {
        width: 212px;
        height: 54px;
        background: linear-gradient(90deg, #7395F4 0%, #AAC9FA 100%);
        border-radius: 10px;
        margin-bottom: 16px;
        cursor: pointer;
        line-height: 54px;
        color: #FFFFFF;
    }

    .left>div:nth-child(2)>div:nth-child(2)>img {
        width: 212px;
        height: 54px;
        border-radius: 10px;
    }

    .left>div:nth-child(2)>div:nth-child(2)>div:nth-child(2) {
        background: linear-gradient(90deg, #8891FC 0%, #B6C0FC 100%);
    }

    .left>div:nth-child(3) {
        /* height: 180px; */
        margin-top: 24px;
    }

    .left>div:nth-child(3)>div {
        height: 60px;
        border-bottom: 1px solid #D8DBF0;
        box-sizing: border-box;
        font-size: 16px;
        color: #999999;
        line-height: 60px;
        padding-left: 24px;
        text-align: left;
        position: relative;
        cursor: pointer;
    }

    .left>div:nth-child(3)>.ac {
        font-weight: bold;
        color: #D70606;
    }

    .left>div:nth-child(3)>.ac::after {
        content: ' ';
        width: 4px;
        height: 34px;
        background: #D70606;
        border-radius: 2px;
        position: absolute;
        left: 0;
        top: calc(50% - 17px);
    }

    .left>div:nth-child(3)>div:last-child {
        border: none;
    }

    .right {
        width: 920px;
        background: #FFFFFF;
        border-radius: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/view/me/me.vue